export default "__VITE_ASSET__BWslMNgR__"